import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { withRouter } from 'react-router-dom';

class ErrorPage extends Component {
  constructor(props) {
    super(props);
    this.state = {
      errorMessage: 'Ha ocurrido un error',
      errorDescription: 'Ocurrió un error al intentar acceder al recurso.'
    };

    this.styles = {
      errorContainer: {
        maxWidth: '600px',
        padding: '20px',
        backgroundColor: '#fff',
        boxShadow: '0 4px 8px rgba(0, 0, 0, 0.1)',
        borderRadius: '8px',
        textAlign: 'center'
      },
      errorMessage: {
        fontSize: '1.5rem',
        marginTop: '10px'
      },
      lead: {
        marginTop: '10px',
        fontSize: '1.1rem',
        color: '#555'
      },
      homeLink: {
        display: 'inline-block',
        marginTop: '30px',
        padding: '10px 20px',
        fontSize: '1.2rem',
        color: '#fff',
        backgroundColor: '#1565d8',
        textDecoration: 'none',
        borderRadius: '5px',
        cursor: 'pointer',
        border: 'none',
        transition: 'background-color 0.3s ease'
      },
      wrapper: {
        fontFamily: 'Arial, sans-serif',
        backgroundColor: '#f8f9fa',
        color: '#333',
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        height: '100vh',
        margin: 0,
        padding: 0,
        boxSizing: 'border-box'
      }
    };
  }

  componentDidMount() {
    // Actualizar la URL a /error cuando el componente se monta
    const { history } = this.props;
    history.replace('/error');
  }

  handleHomeClick = (e) => {
    e.preventDefault();
    //window.location.href = '/';
    window.location.href = '/mirecibo/';
  };

  render() {
    const { errorMessage, errorDescription } = this.state;
    
    return (
      <div style={this.styles.wrapper}>
        <div style={this.styles.errorContainer}>
          <p style={this.styles.errorMessage}>{errorMessage}</p>
          <p style={this.styles.lead}>{errorDescription}</p>
          <button 
            onClick={this.handleHomeClick}
            style={this.styles.homeLink}
          >
            Volver a la página inicial
          </button>
        </div>
      </div>
    );
  }
}

ErrorPage.propTypes = {
  history: PropTypes.object.isRequired
};

// Envolvemos el componente con withRouter para acceder a history
export default withRouter(ErrorPage);
